import { SvgIcon } from '@mui/material';
import React, { FC } from 'react';

interface EyeShutIconProps { }

const EyeShutIcon: FC<EyeShutIconProps> = (props) => (
    <SvgIcon data-testid="EyeShutIcon" {...props}>
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-labelledby="eyeClosedIconTitle" stroke="#000" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" fill="none" color="#000"> <title id="eyeClosedIconTitle">Hidden (closed eye)</title> <path d="M20 9C20 9 19.6797 9.66735 19 10.5144M12 14C10.392 14 9.04786 13.5878 7.94861 13M12 14C13.608 14 14.9521 13.5878 16.0514 13M12 14V17.5M4 9C4 9 4.35367 9.73682 5.10628 10.6448M7.94861 13L5 16M7.94861 13C6.6892 12.3266 5.75124 11.4228 5.10628 10.6448M16.0514 13L18.5 16M16.0514 13C17.3818 12.2887 18.3535 11.3202 19 10.5144M5.10628 10.6448L2 12M19 10.5144L22 12" /> </svg>
    </SvgIcon>
);

export default EyeShutIcon;
